var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"edit_comment_from_dashboard"}},[_c('candidat-comments',{attrs:{"candidat":_vm.selectedCandidat,"fromCorrespondant":false,"canEdit":_vm.can(_vm.Ability.CAND_MANAGE) && _vm.showEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }